import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/payment.ts
const paymentMethodCapabilitySchema = z.object({
	buyerRegion: z.string().optional(),
	code: z.string(),
	name: z.string(),
	supportsAutoDebit: z.boolean(),
	supportedItemTypes: z.array(z.string())
});
/**
* Mirror of the GraphQL `PaymentItemType` enum
* (`PLAN | EXTRA_PACKAGE | ONE_TIME_MEMBERSHIP`). Kept inline so the
* contract package stays free of server-side `generated/graphql`
* imports; the canonical definition lives in the GraphQL schema and is
* regenerated into `generated/graphql.ts` by codegen. Same pattern as
* the campaign-ads / kaisuuken / spring-promo / tier-reward
* migrations.
*/
const getPaymentMethodsInputSchema = z.object({ itemType: z.enum([
	"PLAN",
	"EXTRA_PACKAGE",
	"ONE_TIME_MEMBERSHIP"
]).optional() });
const getPaymentMethodsOutputSchema = z.object({ paymentMethods: z.array(paymentMethodCapabilitySchema) });
const paymentContract = oc.prefix("/payment").tag("Payment").router({ getPaymentMethods: oc.route({
	method: "GET",
	path: "/methods"
}).input(getPaymentMethodsInputSchema).output(getPaymentMethodsOutputSchema).errors({ BAD_REQUEST: {
	status: 400,
	message: "Bad request"
} }) });
//#endregion
export { paymentContract, paymentMethodCapabilitySchema };
